(function () {
  'use strict';

  class BundleCustom {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId;

      var configEl = document.getElementById('BundleCustomConfig-' + this.sectionId);
      if (!configEl) return;
      this.config = JSON.parse(configEl.textContent);

      this.maxProducts = this.config.maxProducts || 99;
      this.tierCount = this.config.tierCount || this.config.tiers.length;
      this.halfColPct = this.config.halfColPct || (this.tierCount > 0 ? 50 / this.tierCount : 50);
      this.cupsPerSachet = this.config.cupsPerSachet || 30;
      this.subDiscountPerProduct = this.config.subDiscountPerProduct || 5;

      this.sortedTiers = this.config.tiers
        .map(function (t, i) { return { index: i, quota: t.quota }; })
        .filter(function (t) { return t.quota > 0; })
        .sort(function (a, b) { return a.quota - b.quota; });

      this.minQuota = this.sortedTiers.length > 0 ? this.sortedTiers[0].quota : 1;

      this.state = {
        currentTier: this.config.defaultTier || 0,
        quantities: {},
        purchaseType: 'onetime'
      };

      this.fbItemMap = {};
      this.fbBundleNumericId = null;
      this.fbBundleUuid = null;

      this.bundleVariantMap = this._buildBundleVariantMap();
      this._prevDotsReached = 0;
      this.giftTierIndex = typeof this.config.giftTierIndex === 'number' ? this.config.giftTierIndex : -1;

      console.log('[BC] Tiers config:', JSON.stringify(this.config.tiers.map(function (t) {
        return { quota: t.quota, autoVariantId: t.autoVariantId };
      })));

      this.cacheDOM();
      this.bindEvents();
      this._bindStickyVisualViewport();
      this._bindCartDrawerHideSticky();
      this.updateUI();

      if (!this.config.bundleProduct) {
        this._loadFbBundleData();
      } else {
        console.log('[BC] Option B active — bundle product:', this.config.bundleProduct.handle,
          'variants:', this.bundleVariantMap);
      }
    }

    _buildBundleVariantMap() {
      var bp = this.config.bundleProduct;
      if (!bp || !bp.variants) return { onetime: {}, subscription: {}, hasSub: false };
      var result = { onetime: {}, subscription: {}, hasSub: false };
      bp.variants.forEach(function (v) {
        var m = v.title.match(/(\d+)/);
        if (!m) return;
        var qty = parseInt(m[1], 10);
        if (/abonnement/i.test(v.title)) {
          result.subscription[qty] = v;
          result.hasSub = true;
        } else {
          result.onetime[qty] = v;
        }
      });
      return result;
    }

    _getBundleVariant(total, purchaseType) {
      var map = (purchaseType === 'subscription' && this.bundleVariantMap.hasSub)
        ? this.bundleVariantMap.subscription
        : this.bundleVariantMap.onetime;
      var variant = map[total];
      if (!variant) {
        var keys = Object.keys(map).map(Number).filter(function (n) { return !isNaN(n); }).sort(function (a, b) { return a - b; });
        var maxKey = keys[keys.length - 1];
        if (total > maxKey) variant = map[maxKey];
      }
      return variant || null;
    }

    _formatPrice(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + '€';
    }
    _formatPerCupPrice(cents, cups) {
      if (!cups || cups <= 0) return '0,00€';
      var eurosPerCup = cents / cups / 100;
      var str = eurosPerCup.toFixed(5);
      var truncated = str.substring(0, str.indexOf('.') + 3);
      return truncated.replace('.', ',') + '€';
    }

    _loadFbBundleData() {
      var self = this;
      var shopDomain = (window.Shopify && window.Shopify.shop) || '';

      var firstCard = this.productCards && this.productCards.length > 0 ? this.productCards[0] : null;
      var childProductId = firstCard ? firstCard.dataset.productId : '';
      if (!shopDomain || !childProductId) {
        console.warn('[BC] Cannot load FB data — shop:', shopDomain, 'childProductId:', childProductId);
        return;
      }

      var url = 'https://api.fastbundle.co/v3/product-bundles/'
        + '?shop=' + encodeURIComponent(shopDomain)
        + '&product_id=' + encodeURIComponent(childProductId)
        + '&lang=en&is_preview=false'
        + '&url=' + encodeURIComponent(window.location.pathname);

      console.log('[BC] Loading FB data, childProductId:', childProductId);
      this._xhr('GET', url).then(function (data) {
        console.log('[BC] FB v3 response:', Array.isArray(data) ? data.length + ' bundle(s)' : typeof data);
        if (Array.isArray(data) && data.length > 0) {
          var bundle = data[0];
          self.fbBundleNumericId = bundle.id;
          self.fbBundleUuid = bundle.uuid || null;
          if (bundle.items) {
            bundle.items.forEach(function (item) {
              if (item.variants) {
                item.variants.forEach(function (v) {
                  self.fbItemMap[String(v.id)] = String(item.item_id);
                });
              }
            });
          }
          console.log('[BC] FB bundle loaded — ID:', self.fbBundleNumericId, 'itemMap:', JSON.stringify(self.fbItemMap));
        } else {
          console.warn('[BC] FB v3 returned empty for childProductId:', childProductId);
        }
      }).catch(function (e) {
        console.warn('[BC] FB bundle data load failed (non-blocking):', e);
      });
    }

    cacheDOM() {
      this.tierLabels = this.section.querySelectorAll('.bc-tier[data-tier-index]');
      this.tierDots = this.section.querySelectorAll('.bc-tiers__dot[data-tier-index]');
      this.productCards = this.section.querySelectorAll('.bc-product-card');
      this.purchaseOptions = this.section.querySelectorAll('.bc-purchase-option');
      this.ctaBtn = this.section.querySelector('.bc-cta');
      this.ctaText = this.section.querySelector('.bc-cta__text');
      this.ctaSpinner = this.section.querySelector('.bc-cta__spinner');

      this.subPriceEl = this.section.querySelector('[data-sub-price]');
      this.subCompareEl = this.section.querySelector('[data-sub-compare]');
      this.subPerCupEl = this.section.querySelector('[data-sub-per-cup]');
      this.onetimeCompareEl = this.section.querySelector('[data-onetime-compare]');
      this.onetimePriceEl = this.section.querySelector('[data-onetime-price]');
      this.onetimePerCupEl = this.section.querySelector('[data-onetime-per-cup]');

      this.benefitSachetsEl = this.section.querySelector('[data-benefit-sachets]');
      this.subBadgeEl = this.section.querySelector('[data-sub-badge]');
      this.ctaPriceEl = this.section.querySelector('[data-cta-price]');
      this.ctaCompareEl = this.section.querySelector('[data-cta-compare]');

      this.stickyContainer = this.config.stickyAtcEnabled ? this.section.querySelector('.bc-sticky-atc') : null;
      this.stickyBtn = this.stickyContainer ? this.stickyContainer.querySelector('.bc-sticky-atc__btn') : null;
      this.stickyText = this.stickyBtn ? this.stickyBtn.querySelector('.bc-sticky-atc__text') : null;
      this.stickyCompareEl = this.stickyBtn ? this.stickyBtn.querySelector('[data-sticky-compare]') : null;
      this.stickyPriceEl = this.stickyBtn ? this.stickyBtn.querySelector('[data-sticky-price]') : null;

      this.sticky2Container = (this.config.stickyAtc2Enabled && this.config.stickyAtc2TriggerProductId)
        ? this.section.querySelector('.bc-sticky-atc-2') : null;
      this.sticky2Btn = this.sticky2Container ? this.sticky2Container.querySelector('.bc-sticky-atc-2__btn') : null;
      this.sticky2Text = this.sticky2Btn ? this.sticky2Btn.querySelector('.bc-sticky-atc-2__text') : null;
      this.sticky2CompareEl = this.sticky2Btn ? this.sticky2Btn.querySelector('[data-sticky-2-compare]') : null;
      this.sticky2PriceEl = this.sticky2Btn ? this.sticky2Btn.querySelector('[data-sticky-2-price]') : null;
      this.sticky2TriggerCard = (this.config.stickyAtc2TriggerProductId)
        ? this.section.querySelector('.bc-product-card[data-product-id="' + this.config.stickyAtc2TriggerProductId + '"]') : null;

      this.popupOverlay = this.section.querySelector('.bc-popup-overlay');
      this.popupInner = this.section.querySelector('.bc-popup__inner');
      this.popupClose = this.section.querySelector('.bc-popup__close');

      this.giftPanels = this.section.querySelectorAll('[data-bc-gift-panel]');

      /* Sticky ATC : attacher au <body> pour que position:fixed + bottom:0 visent bien le viewport.
         Si le bloc reste dans une section avec transform/filter, fixed est relatif au parent → trou sous la barre. */
      if (this.stickyContainer && this.stickyContainer.parentNode !== document.body) {
        this.stickyContainer.setAttribute('data-bc-sticky-portal', '');
        document.body.appendChild(this.stickyContainer);
      }
      if (this.sticky2Container && this.sticky2Container.parentNode !== document.body) {
        this.sticky2Container.setAttribute('data-bc-sticky-portal', '');
        document.body.appendChild(this.sticky2Container);
      }
    }

    /**
     * Chrome mobile : quand la barre d’outils basse réapparaît, le viewport visuel rétrécit mais
     * position:fixed; bottom:0 reste ancré au viewport « layout » → grosse marge blanche.
     * On aligne la barre sur le bas du visual viewport via Visual Viewport API.
     */
    _bindStickyVisualViewport() {
      var self = this;
      if (!this.stickyContainer && !this.sticky2Container) return;
      this._stickyVvRaf = null;
      this._onStickyVv = function () {
        if (self._stickyVvRaf) cancelAnimationFrame(self._stickyVvRaf);
        self._stickyVvRaf = requestAnimationFrame(function () {
          self._stickyVvRaf = null;
          self._syncStickyVisualViewport();
        });
      };
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this._onStickyVv, { passive: true });
        window.visualViewport.addEventListener('scroll', this._onStickyVv, { passive: true });
      }
      window.addEventListener('resize', this._onStickyVv, { passive: true });
      window.addEventListener('orientationchange', this._onStickyVv, { passive: true });
      this._syncStickyVisualViewport();
      /* Chrome : innerHeight / visualViewport se mettent parfois à jour un tick après l’affichage de la barre */
      setTimeout(function () { self._syncStickyVisualViewport(); }, 0);
      setTimeout(function () { self._syncStickyVisualViewport(); }, 250);
    }

    _syncStickyVisualViewport() {
      var els = [];
      if (this.stickyContainer) els.push(this.stickyContainer);
      if (this.sticky2Container) els.push(this.sticky2Container);
      if (!els.length) return;

      var vv = window.visualViewport;
      if (!vv) {
        els.forEach(function (el) {
          el.style.removeProperty('bottom');
        });
        return;
      }

      var layoutH = window.innerHeight;
      var bottomInset = Math.max(0, layoutH - vv.offsetTop - vv.height);
      bottomInset = Math.round(bottomInset * 100) / 100;

      els.forEach(function (el) {
        el.style.bottom = bottomInset + 'px';
      });
    }

    /**
     * Panier (drawer ou page /cart) : les barres sticky restent sur document.body (portal)
     * et passent au-dessus du panier avec le texte produit. On les masque tant que le drawer
     * est ouvert (classe active) ou sur template cart.
     */
    _bindCartDrawerHideSticky() {
      var els = [this.stickyContainer, this.sticky2Container].filter(Boolean);
      if (!els.length) return;

      window.__bcStickyPortalRegistry = window.__bcStickyPortalRegistry || [];
      els.forEach(function (el) {
        if (window.__bcStickyPortalRegistry.indexOf(el) === -1) {
          window.__bcStickyPortalRegistry.push(el);
        }
      });

      function syncAll() {
        var reg = window.__bcStickyPortalRegistry || [];
        var drawer = document.querySelector('cart-drawer');
        var hideDrawer = !!(drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open')));
        var hideCartPage = document.body && document.body.classList.contains('template-cart');
        var hide = hideDrawer || hideCartPage;
        reg.forEach(function (el) {
          if (el && el.isConnected) {
            el.classList.toggle('bc-sticky--cart-hidden', hide);
          }
        });
      }
      window.__bcSyncStickyCartHide = syncAll;

      if (!window.__bcCartDrawerStickyInit) {
        window.__bcCartDrawerStickyInit = true;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          var mo = new MutationObserver(syncAll);
          mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
        }
        window.addEventListener('popstate', syncAll);
        window.addEventListener('pageshow', syncAll);
      }
      syncAll();
    }

    bindEvents() {
      var self = this;

      this.tierLabels.forEach(function (el) {
        el.addEventListener('click', function () {
          self.selectTier(parseInt(el.dataset.tierIndex, 10));
        });
      });
      this.tierDots.forEach(function (el) {
        el.addEventListener('click', function () {
          self.selectTier(parseInt(el.dataset.tierIndex, 10));
        });
      });

      this.productCards.forEach(function (card) {
        var addBtn = card.querySelector('.bc-product-card__add-btn');
        var minusBtn = card.querySelector('.bc-counter__minus');
        var plusBtn = card.querySelector('.bc-counter__plus');
        var infoBtn = card.querySelector('.bc-product-card__info-btn');

        if (addBtn) addBtn.addEventListener('click', function () { self.addProduct(card); });
        if (minusBtn) minusBtn.addEventListener('click', function () { self.decrementProduct(card); });
        if (plusBtn) plusBtn.addEventListener('click', function () { self.incrementProduct(card); });
        if (infoBtn) infoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          self.openInfoPopup(card);
        });
      });

      this.purchaseOptions.forEach(function (opt) {
        opt.addEventListener('click', function () {
          self.setPurchaseType(opt.dataset.type);
        });
      });

      if (this.ctaBtn) {
        this.ctaBtn.addEventListener('click', function () {
          if (!self.ctaBtn.disabled) self.addToCart();
        });
      }

      this.stickyBtnWrap = this.stickyContainer ? this.stickyContainer.querySelector('[data-sticky-atc-2-btn-wrap]') : null;
      if (this.stickyBtnWrap) {
        this.stickyBtnWrap.addEventListener('click', function () {
          if (self.stickyBtn.disabled) {
            if (self.ctaBtn) self.ctaBtn.scrollIntoView({ behavior: 'smooth', block: 'end' });
          } else {
            self.addToCart();
          }
        });
        this.stickyBtnWrap.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (self.stickyBtn.disabled) {
              if (self.ctaBtn) self.ctaBtn.scrollIntoView({ behavior: 'smooth', block: 'end' });
            } else {
              self.addToCart();
            }
          }
        });
      }

      if (this.sticky2Btn) {
        this.sticky2Btn.addEventListener('click', function () {
          if (!self.sticky2Btn.disabled) self.addToCart();
        });
      }

      if (this.ctaBtn && this.stickyContainer && this.config.stickyAtcEnabled) {
        var hasSeenCta = false;
        var showOnlyBelow = this.config.stickyShowOnlyBelowCta !== false;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.target !== self.ctaBtn) return;
            if (e.isIntersecting) {
              hasSeenCta = true;
              self.stickyContainer.classList.remove('sticky-visible');
              self.stickyContainer.setAttribute('aria-hidden', 'true');
              return;
            }
            var rect = e.boundingClientRect;
            var ctaAboveViewport = rect.bottom <= 0;
            var shouldShow = showOnlyBelow
              ? (hasSeenCta && ctaAboveViewport)
              : true;
            self.stickyContainer.classList.toggle('sticky-visible', shouldShow);
            self.stickyContainer.setAttribute('aria-hidden', !shouldShow);
          });
        }, { root: null, rootMargin: '0px', threshold: 0 });
        io.observe(self.ctaBtn);
      }

      if (this.sticky2Container && this.sticky2TriggerCard && this.ctaBtn) {
        var triggerVisible = false;
        var ctaVisible = false;
        function updateSticky2() {
          var show = triggerVisible && !ctaVisible;
          self.sticky2Container.classList.toggle('sticky-visible', show);
          self.sticky2Container.setAttribute('aria-hidden', !show);
        }
        var ioTrigger = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.target !== self.sticky2TriggerCard) return;
            triggerVisible = e.isIntersecting;
            updateSticky2();
          });
        }, { root: null, rootMargin: '0px', threshold: 0 });
        var ioCta = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.target !== self.ctaBtn) return;
            ctaVisible = e.isIntersecting;
            updateSticky2();
          });
        }, { root: null, rootMargin: '0px', threshold: 0 });
        ioTrigger.observe(self.sticky2TriggerCard);
        ioCta.observe(self.ctaBtn);
      }

      if (this.popupClose) {
        this.popupClose.addEventListener('click', function () { self.closeInfoPopup(); });
      }
      if (this.popupOverlay) {
        this.popupOverlay.addEventListener('click', function (e) {
          if (e.target === self.popupOverlay) self.closeInfoPopup();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.popupOverlay && !self.popupOverlay.hidden) {
          self.closeInfoPopup();
        }
      });
    }

    /* ── Popup ── */
    openInfoPopup(card) {
      var tpl = card.querySelector('.bc-popup-tpl');
      if (!tpl || !this.popupInner || !this.popupOverlay) return;
      this.popupInner.innerHTML = tpl.innerHTML;
      this.popupOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    closeInfoPopup() {
      if (!this.popupOverlay) return;
      this.popupOverlay.hidden = true;
      document.body.style.overflow = '';
    }

    /* ── State ── */
    get totalSelected() {
      var sum = 0;
      for (var key in this.state.quantities) {
        sum += this.state.quantities[key];
      }
      return sum;
    }

    get canAddMore() {
      if (this.config.bundleProduct) {
        var keys = Object.keys(this.bundleVariantMap.onetime).map(Number).filter(function (n) { return !isNaN(n); });
        var maxVariant = keys.length > 0 ? Math.max.apply(null, keys) : this.maxProducts;
        return this.totalSelected < maxVariant;
      }
      return this.totalSelected < this.maxProducts;
    }

    autoSelectTier() {
      var total = this.totalSelected;
      if (total === 0) {
        this.state.currentTier = this.config.defaultTier || 0;
        return;
      }

      var best = -1;
      for (var i = 0; i < this.sortedTiers.length; i++) {
        var t = this.sortedTiers[i];
        if (t.quota >= total) {
          best = t.index;
          break;
        }
      }

      if (best === -1 && this.sortedTiers.length > 0) {
        best = this.sortedTiers[this.sortedTiers.length - 1].index;
      }

      if (best >= 0) this.state.currentTier = best;
    }

    selectTier(index) {
      this.state.currentTier = index;
      this.state.quantities = {};
      this.updateUI();
    }

    addProduct(card) {
      if (!this.canAddMore || card.dataset.oos === 'true') return;
      var id = card.dataset.productId;
      this.state.quantities[id] = (this.state.quantities[id] || 0) + 1;
      this.updateUI();
    }

    incrementProduct(card) {
      if (!this.canAddMore || card.dataset.oos === 'true') return;
      var id = card.dataset.productId;
      this.state.quantities[id] = (this.state.quantities[id] || 0) + 1;
      this.updateUI();
    }

    decrementProduct(card) {
      var id = card.dataset.productId;
      if (this.state.quantities[id] && this.state.quantities[id] > 0) {
        this.state.quantities[id] -= 1;
        if (this.state.quantities[id] <= 0) delete this.state.quantities[id];
        this.updateUI();
      }
    }

    setPurchaseType(type) {
      if (type === this.state.purchaseType) return;
      this.state.purchaseType = type;
      this.updateUI();
    }

    /* ── UI Updates ── */
    updateUI() {
      this.autoSelectTier();
      this.updateProgressBar();
      this.updateGiftPanelVisibility();
      this.updateProductCardsUI();
      this.updatePricingUI();
      this.updateCTAUI();
      this.updatePurchaseTypeUI();
      this.updateBenefitText();
      this.updateSubBadge();
    }

    updateProgressBar() {
      var N = this.tierCount;
      if (N <= 1) return;

      var total = this.totalSelected;
      var dotsReached = Math.min(total, N);
      var prev = this._prevDotsReached;
      var trackWidth = 100 - 2 * this.halfColPct;

      var fillWidth = dotsReached > 1
        ? ((dotsReached - 1) / (N - 1)) * trackWidth
        : 0;

      this.section.style.setProperty('--bc-fill', fillWidth + '%');

      this.tierDots.forEach(function (dot) {
        var idx = parseInt(dot.dataset.tierIndex, 10);
        dot.classList.toggle('is-reached', idx < dotsReached);
        dot.classList.toggle('is-active', dotsReached > 0 && idx === dotsReached - 1);
      });

      this.tierLabels.forEach(function (el) {
        var idx = parseInt(el.dataset.tierIndex, 10);
        el.classList.toggle('is-reached', idx < dotsReached);
        el.classList.toggle('is-active', dotsReached > 0 && idx === dotsReached - 1);
      });

      var gi = this.giftTierIndex;
      if (gi >= 0 && prev < gi + 1 && dotsReached >= gi + 1) {
        this._triggerGiftTierEffects();
      }
      this._prevDotsReached = dotsReached;
    }

    /** Bloc « Cadeau offert » : visible seulement quand le palier cadeau est atteint (ex. 2e produit si giftTierIndex = 1). */
    updateGiftPanelVisibility() {
      if (!this.giftPanels || !this.giftPanels.length) return;
      var gi = this.giftTierIndex;
      var N = this.tierCount;
      var dotsReached = N > 0 ? Math.min(this.totalSelected, N) : 0;
      var show = gi >= 0 && dotsReached >= gi + 1;
      this.giftPanels.forEach(function (el) {
        el.hidden = !show;
        el.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }

    _triggerGiftTierEffects() {
      var giftBtn = this.section.querySelector('[data-gift-dot]');
      if (giftBtn) {
        giftBtn.querySelectorAll('[data-gift-ring]').forEach(function (el, i) {
          el.className = 'bc-tiers__gift-ring';
          void el.offsetWidth;
          el.classList.add('fire-' + (i + 1));
        });
      }
      var badge = this.section.querySelector('[data-gift-badge-tier]');
      if (badge) {
        badge.classList.remove('unlock');
        void badge.offsetWidth;
        badge.classList.add('unlock');
      }
    }

    updateProductCardsUI() {
      var self = this;
      var atMax = !this.canAddMore;

      this.productCards.forEach(function (card) {
        var id = card.dataset.productId;
        var qty = self.state.quantities[id] || 0;
        var addBtn = card.querySelector('.bc-product-card__add-btn');
        var counter = card.querySelector('.bc-product-card__counter');
        var valueEl = card.querySelector('.bc-counter__value');

        if (qty > 0) {
          addBtn.hidden = true;
          counter.hidden = false;
          valueEl.textContent = qty;
        } else {
          addBtn.hidden = false;
          counter.hidden = true;
        }

        addBtn.disabled = atMax;
        var plusBtn = card.querySelector('.bc-counter__plus');
        if (plusBtn) plusBtn.disabled = atMax;
      });
    }

    updatePricingUI() {
      if (this.config.bundleProduct) {
        var total = Math.max(this.totalSelected, 1);
        var ov = this._getBundleVariant(total, 'onetime');
        var sv = this._getBundleVariant(total, 'subscription');
        var cups = total * this.cupsPerSachet;

        if (ov) {
          var ovCompare = ov.compare_at_price != null ? ov.compare_at_price : (ov.compareAt || 0);
          if (this.onetimeCompareEl) {
            this.onetimeCompareEl.textContent = (ovCompare > ov.price) ? this._formatPrice(ovCompare) : '';
          }
          if (this.onetimePriceEl) this.onetimePriceEl.textContent = this._formatPrice(ov.price);
          if (this.onetimePerCupEl) this.onetimePerCupEl.textContent = this._formatPerCupPrice(ov.price, cups) + '/tasse';
        }
        if (sv && this.bundleVariantMap.hasSub) {
          if (this.subPriceEl) this.subPriceEl.textContent = this._formatPrice(sv.price);
          /* Prix barré abonnement = compare_at de la variante achat unique (pas le prix one-shot), pour un écart plus visible */
          var subCompareCents = 0;
          if (ov) {
            subCompareCents = ov.compare_at_price != null ? ov.compare_at_price : (ov.compareAt || 0);
          }
          if (this.subCompareEl) {
            this.subCompareEl.textContent = (subCompareCents > sv.price) ? this._formatPrice(subCompareCents) : '';
          }
          if (this.subPerCupEl) this.subPerCupEl.textContent = this._formatPerCupPrice(sv.price, cups) + '/tasse';
        } else if (ov) {
          var subCents = Math.max(0, ov.price - total * this.subDiscountPerProduct * 100);
          var subCompareFallback = ov.compare_at_price != null ? ov.compare_at_price : (ov.compareAt || 0);
          if (this.subPriceEl) this.subPriceEl.textContent = this._formatPrice(subCents);
          if (this.subCompareEl) {
            this.subCompareEl.textContent = (subCompareFallback > subCents) ? this._formatPrice(subCompareFallback) : '';
          }
          if (this.subPerCupEl) this.subPerCupEl.textContent = this._formatPerCupPrice(subCents, cups) + '/tasse';
        }
        return;
      }

      var tier = this.config.tiers[this.state.currentTier];
      if (!tier) return;
      if (this.subPriceEl) this.subPriceEl.textContent = tier.subPrice || '';
      if (this.subCompareEl) this.subCompareEl.textContent = tier.subCompare || '';
      if (this.subPerCupEl) this.subPerCupEl.textContent = tier.subPerCup || '';
      if (this.onetimeCompareEl) this.onetimeCompareEl.textContent = '';
      if (this.onetimePriceEl) this.onetimePriceEl.textContent = tier.onetimePrice || '';
      if (this.onetimePerCupEl) this.onetimePerCupEl.textContent = tier.onetimePerCup || '';
    }

    updateBenefitText() {
      if (!this.benefitSachetsEl) return;
      var count = Math.max(this.totalSelected, 1);
      var cups = count * this.cupsPerSachet;
      this.benefitSachetsEl.innerHTML = '<span class="bc-benefit-check">\u2713</span> <strong>'
        + count + ' sachet' + (count > 1 ? 's' : '')
        + '</strong> - ' + cups + ' tasses';
    }

    updateSubBadge() {
      if (!this.subBadgeEl) return;
      var count = this.totalSelected;
      var text = '';
      if (this.config.bundleProduct && this.bundleVariantMap.hasSub) {
        /* Abonnement uniquement : paliers fixes (€ puis % à partir du 3e produit) */
        if (count <= 1) text = '-16€';
        else if (count === 2) text = '-42€';
        else if (count === 3) text = '-45%';
        else if (count >= 4) text = '-50%';
      } else if (count > 0) {
        text = '- ' + (count * this.subDiscountPerProduct) + '€';
      }
      this.subBadgeEl.textContent = text;
      this.subBadgeEl.style.display = text ? '' : 'none';
    }

    updatePurchaseTypeUI() {
      var type = this.state.purchaseType;
      this.purchaseOptions.forEach(function (opt) {
        var isActive = opt.dataset.type === type;
        opt.classList.toggle('is-selected', isActive);
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = isActive;
      });
    }

    updateCTAUI() {
      if (!this.ctaBtn) return;
      var total = this.totalSelected;
      var remaining = this.minQuota - total;
      var tier = this.config.tiers[this.state.currentTier];
      var price = '';
      var comparePrice = '';

      if (this.config.bundleProduct && total > 0) {
        var bv = this._getBundleVariant(total, this.state.purchaseType);
        if (bv) {
          price = this._formatPrice(bv.price);
          var cCompare = 0;
          if (this.state.purchaseType === 'subscription' && this.bundleVariantMap.hasSub) {
            var ovCta = this._getBundleVariant(total, 'onetime');
            if (ovCta) {
              cCompare = ovCta.compare_at_price != null ? ovCta.compare_at_price : (ovCta.compareAt || 0);
            }
          } else {
            cCompare = bv.compare_at_price != null ? bv.compare_at_price : (bv.compareAt || 0);
          }
          if (cCompare > bv.price) {
            comparePrice = this._formatPrice(cCompare);
          }
        }
      } else if (tier) {
        price = this.state.purchaseType === 'subscription'
          ? (tier.subPrice || '')
          : (tier.onetimePrice || '');
      }

      if (total >= this.minQuota) {
        this.ctaBtn.disabled = false;
        this.ctaText.textContent = this.config.ctaComplete;
      } else if (total === 0) {
        this.ctaBtn.disabled = true;
        this.ctaText.textContent = this.config.ctaEmpty || 'Sélectionnez au moins une saveur';
      } else {
        this.ctaBtn.disabled = true;
        this.ctaText.textContent = this.config.ctaIncomplete.replace('{count}', Math.max(remaining, 1));
      }

      if (this.ctaCompareEl) {
        if (!this.ctaBtn.disabled && comparePrice) {
          this.ctaCompareEl.innerHTML = '<span class="bc-cta__compare-price">' + comparePrice + '</span>';
        } else {
          this.ctaCompareEl.textContent = '';
        }
      }
      if (this.ctaPriceEl) {
        this.ctaPriceEl.textContent = (!this.ctaBtn.disabled && price) ? (comparePrice ? '' : '') + price : '';
      }

      if (this.stickyBtn && this.stickyText) {
        this.stickyBtn.disabled = this.ctaBtn.disabled;
        this.stickyText.textContent = this.ctaText.textContent;
        if (this.stickyCompareEl) {
          if (!this.ctaBtn.disabled && comparePrice) {
            this.stickyCompareEl.innerHTML = '<span class="bc-sticky-atc__compare-price">' + comparePrice + '</span>';
          } else {
            this.stickyCompareEl.textContent = '';
          }
        }
        if (this.stickyPriceEl) {
          this.stickyPriceEl.textContent = (!this.ctaBtn.disabled && price) ? price : '';
        }
      }

      if (this.sticky2Btn && this.sticky2Text) {
        this.sticky2Btn.disabled = this.ctaBtn.disabled;
        this.sticky2Text.textContent = this.ctaText.textContent;
        if (this.sticky2CompareEl) {
          if (!this.ctaBtn.disabled && comparePrice) {
            this.sticky2CompareEl.innerHTML = '<span class="bc-sticky-atc-2__compare-price">' + comparePrice + '</span>';
          } else {
            this.sticky2CompareEl.textContent = '';
          }
        }
        if (this.sticky2PriceEl) {
          this.sticky2PriceEl.textContent = (!this.ctaBtn.disabled && price) ? price : '';
        }
      }
    }

    /* ── Add to Cart ── */
    async addToCart() {
      console.log('[BC] addToCart — purchaseType:', this.state.purchaseType, 'quantities:', JSON.stringify(this.state.quantities));
      this.ctaBtn.disabled = true;
      this.ctaText.hidden = true;
      this.ctaSpinner.hidden = false;
      if (this.stickyBtn) this.stickyBtn.disabled = true;
      if (this.sticky2Btn) this.sticky2Btn.disabled = true;

      try {
        if (this.config.bundleProduct) {
          await this._addToCartOptionB();
        } else {
          await this._addToCartFastBundle();
        }
      } catch (err) {
        console.error('[BC] Add to cart error:', err);
        alert('Erreur: ' + err.message);
        this.resetCTA();
      }
    }

    /* Option B: native Shopify variant + line item properties */
    async _addToCartOptionB() {
      var self = this;
      var total = this.totalSelected;
      if (total === 0) throw new Error('Aucun produit sélectionné');

      var variant = this._getBundleVariant(total, this.state.purchaseType);
      if (!variant) throw new Error('Aucune variante bundle trouvée pour ' + total + ' sachet(s)');

      var flavorParts = [];
      this.productCards.forEach(function (card) {
        var pid = card.dataset.productId;
        var qty = self.state.quantities[pid] || 0;
        if (qty > 0) {
          var name = card.dataset.productTitle || card.querySelector('.bc-product-card__name')?.textContent?.trim() || pid;
          flavorParts.push(name + (qty > 1 ? ' ×' + qty : ''));
        }
      });

      var properties = { 'Saveurs': flavorParts.join(', ') };

      var slotIndex = 1;
      this.productCards.forEach(function (card) {
        var pid = card.dataset.productId;
        var vid = card.dataset.variantId;
        var qty = self.state.quantities[pid] || 0;
        if (qty > 0) {
          var name = card.dataset.productTitle || card.querySelector('.bc-product-card__name')?.textContent?.trim() || pid;
          properties[name] = String(qty);
          if (vid) {
            properties['_bc_v' + slotIndex + '_id'] = String(vid);
            properties['_bc_v' + slotIndex + '_qty'] = String(qty);
            slotIndex++;
          }
        }
      });

      var bundleItem = {
        id: variant.id,
        quantity: 1,
        properties: properties
      };
      if (this.state.purchaseType === 'subscription' && this.config.sellingPlanId) {
        bundleItem.selling_plan = parseInt(this.config.sellingPlanId, 10);
      }

      console.log('[BC] Option B — variant:', variant.id, '(' + variant.title + ')', 'price:', variant.price,
        'properties:', JSON.stringify(properties));

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [bundleItem] })
      });

      if (!res.ok) {
        var errData = {}; try { errData = await res.json(); } catch (e) {}
        throw new Error(errData.description || errData.message || 'HTTP ' + res.status);
      }

      var result = await res.json();
      console.log('[BC] /cart/add.js OK:', result.items ? result.items.length + ' item(s)' : result);

      var autoItems = [];
      var addedAutoVariants = {};
      this.config.tiers.forEach(function (tier) {
        console.log('[BC] Auto-add check — quota:', tier.quota, 'autoVariantId:', tier.autoVariantId, 'total:', total);
        if (tier.autoVariantId && tier.quota > 0 && total >= tier.quota && !addedAutoVariants[tier.autoVariantId]) {
          autoItems.push({ id: parseInt(tier.autoVariantId, 10), quantity: 1 });
          addedAutoVariants[tier.autoVariantId] = true;
        }
      });

      if (autoItems.length > 0) {
        console.log('[BC] Auto-add items:', JSON.stringify(autoItems));
        try {
          var autoRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: autoItems })
          });
          if (!autoRes.ok) {
            var autoErr = {}; try { autoErr = await autoRes.json(); } catch (e) {}
            console.warn('[BC] Auto-add failed:', autoRes.status, autoErr.description || autoErr.message || '');
          } else {
            var autoResult = await autoRes.json();
            console.log('[BC] Auto-add OK:', autoResult.items ? autoResult.items.length + ' item(s)' : autoResult);
          }
        } catch (e) {
          console.warn('[BC] Auto-add error:', e);
        }
      } else {
        console.log('[BC] No auto-add items matched (total:', total, ')');
      }

      var drawerOpened = await this.openCartDrawer();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      if (!drawerOpened) {
        window.location.href = '/cart';
      } else {
        this.state.quantities = {};
        this.updateUI();
        this.resetCTA();
      }
    }

    /* Legacy Fast Bundle path */
    async _addToCartFastBundle() {
      var self = this;
      var items = [];
      var bundleVariants = [];

      this.productCards.forEach(function (card) {
        var pid = card.dataset.productId;
        var vid = card.dataset.variantId;
        var qty = self.state.quantities[pid] || 0;
        if (qty > 0 && vid) {
          var lineItem = { id: parseInt(vid, 10), quantity: qty };
          if (self.state.purchaseType === 'subscription' && self.config.sellingPlanId) {
            lineItem.selling_plan = parseInt(self.config.sellingPlanId, 10);
          }
          items.push(lineItem);

          var fbItemId = self.fbItemMap[vid];
          if (fbItemId) {
            for (var q = 0; q < qty; q++) {
              bundleVariants.push({ variant_id: parseInt(vid, 10), item_id: parseInt(fbItemId, 10) });
            }
          }
        }
      });

      if (items.length === 0) throw new Error('Aucun produit sélectionné');

      var total = self.totalSelected;
      var addedAutoVariants = {};
      self.config.tiers.forEach(function (tier) {
        if (tier.autoVariantId && tier.quota > 0 && total >= tier.quota && !addedAutoVariants[tier.autoVariantId]) {
          items.push({ id: parseInt(tier.autoVariantId, 10), quantity: 1 });
          addedAutoVariants[tier.autoVariantId] = true;
        }
      });

      console.log('[BC] Sending to /cart/add.js via FETCH, items:', JSON.stringify(items));
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!res.ok) {
        var errData = {}; try { errData = await res.json(); } catch (e) {}
        throw new Error(errData.description || errData.message || 'HTTP ' + res.status);
      }

      var result = await res.json();
      console.log('[BC] /cart/add.js status:', res.status, 'OK:', JSON.stringify(result).substring(0, 300));

      if (typeof window.detectBundleDiscounts === 'function') {
        console.log('[BC] Calling detectBundleDiscounts()...');
        try { await window.detectBundleDiscounts(); } catch (e) { console.warn('[BC] detect error:', e); }
      }

      await new Promise(function (r) { setTimeout(r, 2000); });
      var finalCart = await self._xhr('GET', '/cart.js');
      console.log('[BC] Final cart — total:', finalCart.total_price, 'discount:', finalCart.total_discount);

      var drawerOpened = await this.openCartDrawer();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      if (!drawerOpened) {
        window.location.href = '/cart';
      } else {
        self.state.quantities = {};
        self.updateUI();
        self.resetCTA();
      }
    }

    _xhr(method, url, data) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        if (data) xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = function () {
          console.log('[BC] XHR', method, url, 'status:', xhr.status);
          var parsed;
          try { parsed = JSON.parse(xhr.responseText); } catch (e) { parsed = null; }
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(parsed || {});
          } else {
            var msg = (parsed && (parsed.description || parsed.message || parsed.error)) || ('HTTP ' + xhr.status);
            console.error('[BC] XHR error:', url, xhr.status, msg, '| raw:', xhr.responseText.substring(0, 500));
            reject(new Error(url + ' -> ' + xhr.status + ' ' + msg));
          }
        };
        xhr.onerror = function () {
          console.error('[BC] XHR network error:', url);
          reject(new Error('Network error: ' + url));
        };
        xhr.send(data ? JSON.stringify(data) : null);
      });
    }

    async openCartDrawer() {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return false;

      try {
        var sectionsUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart')
          + '?sections=cart-drawer,cart-icon-bubble';
        var sectionResponse = await fetch(sectionsUrl);
        var sectionData = await sectionResponse.json();

        if (sectionData['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sectionData['cart-drawer'], 'text/html');
          var freshDrawer = doc.querySelector('cart-drawer');
          if (freshDrawer) {
            cartDrawer.innerHTML = freshDrawer.innerHTML;
            cartDrawer.className = freshDrawer.className;
          }
        }

        cartDrawer.classList.add('active');
        cartDrawer.classList.remove('is-empty');
        if (typeof window.__bcSyncStickyCartHide === 'function') window.__bcSyncStickyCartHide();

        if (sectionData['cart-icon-bubble']) {
          var cartBubble = document.getElementById('cart-icon-bubble');
          if (cartBubble) {
            var bp = new DOMParser();
            var bd = bp.parseFromString(sectionData['cart-icon-bubble'], 'text/html');
            var newBubble = bd.querySelector('[id="cart-icon-bubble"]');
            if (newBubble) cartBubble.innerHTML = newBubble.innerHTML;
          }
        }

        return true;
      } catch (e) {
        console.warn('[BundleCustom] Cart drawer error:', e);
        return false;
      }
    }

    resetCTA() {
      this.ctaText.hidden = false;
      this.ctaSpinner.hidden = true;
      this.updateCTAUI();
    }
  }

  function init() {
    document.querySelectorAll('.bc-section[data-section-id]').forEach(function (el) {
      if (!el._bundleCustom) {
        el._bundleCustom = new BundleCustom(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.bc-section[data-section-id]');
      if (section) section._bundleCustom = new BundleCustom(section);
    });
  }
})();
